export default "__VITE_ASSET__loAfJttv__"